module.exports = {"TXTCLI_More":{"id":"TXTCLI_More","defaultMessage":"Mer","flags":["TRACK"],"track":"More"}}